module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel04_1280_1280_zh-hant-58fd18927040116260437f8c2b1ef845.jpg";